const PRIMARY_COLOR = "#FFB829";
const SECONDARY_COLOR = "#FF1D89";
const BG_COLOR = "#F2F1F0"

const lightTheme = {
  primaryColor: PRIMARY_COLOR,
  secondaryColor: SECONDARY_COLOR,
  backgroundColor: BG_COLOR,
  appbarColor: `linear-gradient(269.14deg, #FFE83A 0.75%, #FF961B 99.27%)`,
  navbarColor: `linear-gradient(269.14deg, #FFE83A 0.75%, #FF961B 99.27%)`,
  buttonColor: `linear-gradient(269.14deg, #FFE83A 0.75%, #FF961B 99.27%)`,
  buttonHoverColor: `linear-gradient(269.14deg, #FFE83A 0.75%, #FF961B 99.27%)`,
};

export default lightTheme;
